module.exports = __webpack_public_path__ + "img/black-tick.694fb5b1.svg";